import React from 'react';
import Authenticator from './authenticator';

const AuthenticatorContext = React.createContext<Authenticator>(new Authenticator());

export default AuthenticatorContext;
